import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles, Share2, Copy, RefreshCw } from "lucide-react";
import { fill, shareOut, copyOut, personalLink } from "@/lib/partnerKit";

const dayIndex = () => Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 864e5);

// "Give me something to post today": the day's approved post, already personalised.
export default function PostToday({ k }) {
  const posts = k.copy.daily_posts || [];
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(dayIndex());
  if (!posts.length) return null;
  const p = posts[i % posts.length];
  const ch = { "linkedin / x": "linkedin" }[p.channel.toLowerCase()] || p.channel.toLowerCase();
  const text = fill(p.text, { name: k.name, link: personalLink(k.slug, ch), code: k.code });
  const log = { intent: "today", channel: p.channel.toLowerCase() };
  return (
    <div className="mt-4">
      {!open ? (
        <button onClick={() => setOpen(true)} data-testid="post-today-btn"
          className="w-full flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground py-4 font-medium hover:opacity-90 active:scale-[0.99] transition-[opacity,transform] duration-200">
          <Sparkles className="w-4 h-4" /> Give me something to post today
        </button>
      ) : (
        <AnimatePresence mode="wait">
          <motion.div key={i} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="rounded-3xl border border-primary/30 bg-gradient-to-br from-primary/[0.1] to-transparent p-6" data-testid="post-today-card">
            <p className="text-[10px] uppercase tracking-[0.22em] text-primary">Today · {p.channel}</p>
            <p className="mt-3 whitespace-pre-line leading-relaxed" data-testid="post-today-text">{text}</p>
            <div className="flex flex-wrap gap-2 mt-5">
              <button onClick={() => shareOut({ text, log })} className="inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm" data-testid="post-today-share"><Share2 className="w-4 h-4" /> Share</button>
              <button onClick={() => copyOut(text, log)} className="inline-flex items-center gap-1.5 rounded-full border border-border px-5 py-2.5 text-sm" data-testid="post-today-copy"><Copy className="w-4 h-4" /> Copy</button>
              <button onClick={() => setI(i + 1)} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2.5 text-sm text-muted-foreground hover:text-foreground" data-testid="post-today-another"><RefreshCw className="w-4 h-4" /> Another</button>
            </div>
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  );
}
